import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { HelperMethods } from '../editor/editor-helper';
/**
 * @private
 */
export class WAbstractList {
    constructor() {
        this.abstractListIdIn = -1;
        this.nsid = -1;
        this.levels = [];
        this.nsid = parseInt(HelperMethods.generateHexDecimal(), 16);
    }
    get abstractListId() {
        return this.abstractListIdIn;
    }
    set abstractListId(abstractListId) {
        this.abstractListIdIn = abstractListId;
    }
    clear() {
        if (!isNullOrUndefined(this.levels)) {
            for (let i = 0; i < this.levels.length; i++) {
                const listLevel = this.levels[parseInt(i.toString(), 10)];
                listLevel.clearFormat();
                this.levels.splice(this.levels.indexOf(listLevel), 1);
                i--;
            }
            this.levels = [];
        }
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     * @returns {void}
     */
    destroy() {
        if (!isNullOrUndefined(this.levels)) {
            for (let i = 0; i < this.levels.length; i++) {
                const listLevel = this.levels[parseInt(i.toString(), 10)];
                listLevel.destroy();
                this.levels.splice(this.levels.indexOf(listLevel), 1);
                i--;
            }
            this.levels = [];
        }
        this.levels = undefined;
    }
    clone() {
        const absList = new WAbstractList();
        for (let i = 0; i < this.levels.length; i++) {
            absList.levels.push(this.levels[parseInt(i.toString(), 10)].clone(absList));
        }
        return absList;
    }
}
